<template>
  <div class="animated fadeIn step-container">
    <div class="row">
      <div class="col-md-8 offset-md-2 d-flex justify-content-start">
        <h2 class="p-2">{{$t('message.report.title')}}</h2>
        <multiselect id="date-filter"
                    class="multi-select-form ml-auto p-2"
                    style="width: auto;"
                    v-model="selectedDateFilter" 
                    :options="dateFilterOptions" 
                    :multiple="false"
                    :allow-empty="false" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
      </div>

      <div v-if="loading" class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-block text-center">
            <div style="width:60px; margin:auto;"> 
              <dot-loader size='60px'></dot-loader>
            </div>
          </div>
        </div>
      </div>

      <!-- Appointment Chart -->
      <div v-if="!loading" class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-block">
            <h4>{{$t('message.report.view_and_appointment')}}</h4>
          </div>

          <ul class="list-group list-group-flush">
             <li class="list-group-item group-item-box">
              <tabs v-model="activeTab" nav-style="tabs" justified class="appointmentStatTab">
                <tab :header="`<h6 class='apm-cnt-title'>นัดหมาย</h6><h2>${appointmentStatChartData.count}</h2>`">
                  <report-line-chart class="chart-wrapper px-3" style="height:12rem;" :chartData="appointmentStatChartData" />
                </tab>
                <tab :header="`<h6 class='apm-cnt-title'>ผู้เยี่ยมชม</h6><h2>${viewStatChartData.count}</h2>`">
                  <report-line-chart class="chart-wrapper px-3" style="height:12rem;" :chartData="viewStatChartData" />
                </tab>
              </tabs>
             </li>
          </ul>
        </div>
      </div>

      <!-- Appointment Status -->
      <div v-if="!loading" class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-block">
            <h4>{{$t('message.report.status_summary')}}</h4>
          </div>

          <ul class="list-group list-group-flush">
             <li class="list-group-item group-item-box">
              <tabs nav-style="tabs" justified class="appointmentStatusStatTab">
                <tab :header="`<h6 class='apm-status-cnt-title'>${$t('message.report.status_pending')}</h6><h2>${getAppointmentStatusCount('pending')}</h2>`">
                </tab>
                <tab :header="`<h6 class='apm-status-cnt-title'>${$t('message.report.status_checkin')}</h6><h2>${getAppointmentStatusCount('checkin')}</h2>`">
                </tab>
                <tab :header="`<h6 class='apm-status-cnt-title'>${$t('message.report.status_cancel')}</h6><h2>${getAppointmentStatusCount('cancel')}</h2>`">
                </tab>
                <tab :header="`<h6 class='apm-status-cnt-title'>${$t('message.report.status_scheduled')}</h6><h2>${getAppointmentStatusCount('scheduled')}</h2>`">
                </tab>
              </tabs>
             </li>
          </ul>
        </div>
      </div>

      <!-- Gender stat -->
       <div v-if="!loading" class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-block">
            <h4>{{$t('message.report.visitor_detail')}}</h4>
          </div>

          <ul class="list-group list-group-flush">
            <li class="list-group-item group-item-box gender-progress-box">
              <div class="row">
                <div class="col-md-2 text-center">
                  <i class="fa fa-male" aria-hidden="true"></i>  {{$t('message.report.male')}}
                </div>
                <div class="col-md-10">
                  <div class="progress">
                    <div class="progress-bar male-progress" role="progressbar" :style="{width: `${malePercent}%`}" aria-valuenow="25" aria-valuemin="0" :aria-valuemax="malePercent"></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2 text-center">
                  <i class="fa fa-female" aria-hidden="true"></i>  {{$t('message.report.female')}}
                </div>
                <div class="col-md-10">
                  <div class="progress">
                    <div class="progress-bar female-progress" role="progressbar" :style="{width: `${femalePercent}%`}" aria-valuenow="25" aria-valuemin="0" :aria-valuemax="femalePercent"></div>
                  </div>
                </div>
              </div>
            </li>
            <!-- <li class="list-group-item group-item-box">
              <report-bar-chart class="chart-wrapper px-3" style="height:12rem;" :chartData="genderStatChartData" />
            </li> -->
          </ul>
        </div>
      </div>

      <!-- Articles -->
      <div v-if="!loading" class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-block">
            <h4>{{$t('message.report.article')}}</h4>
          </div>

          <table class='table table-striped'>
            <thead>
              <tr>
                <th>{{$t('message.report.popular_article')}}</th>
                <th class="text-center">{{$t('message.report.article_visitor')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(article, index) in stats.articleStat" :key="index">
                <td class="text-truncate"><a href="javascript:void(0)" @click.prevent="openPath(`${article.path}`)">{{article.title}}</a></td>
                <td class="text-center">{{article.count}}</td>
              </tr>
              <tr v-if="stats.articleStat.length === 0">
                <td colspan='3' style='text-align: center;' class='alert alert-warning'><span>{{$t('message.report.no_article')}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Doctors of clinic -->
      <div v-if="$guser.isClinic() && !loading" class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-block">
            <h4>{{$t('message.report.popular_doctor')}}</h4>
          </div>

          <table class='table table-striped'>
            <thead>
              <tr>
                <th class="text-center">{{$t('message.report.doctor_rank')}}</th>
                <th class="text-center">{{$t('message.report.doctor_name')}}</th>
                <th class="text-center">{{$t('message.report.doctor_appointment_count')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(doctor, index) in orderedDoctorStat" :key="index">
                <td class="text-center align-middle">{{index+1}}{{index+1 | pluralize('st','nd','rd','th')}}</td>
                <td class="text-truncate">
                  <div>
                    <a href="javascript:void(0)" @click.prevent="openPath(`/doctor/${doctor.doctor_id}`)">{{getDoctorName(doctor)}}</a>
                  </div>
                  <!-- <small class="text-truncate">{{`Specialty`}}</small> -->
                </td>
                <td class="text-center align-middle">{{doctor.appointment_count}}</td>
              </tr>
              <tr v-if="orderedDoctorStat.length === 0">
                <td colspan='3' style='text-align: center;' class='alert alert-warning'><span>ไม่พบหมอ</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportLineChart from '@/components/chart/LineChart'
import ReportBarChart from '@/components/chart/BarChart'
import SyncLoader from 'vue-spinner/src/SyncLoader'
import DotLoader from 'vue-spinner/src/DotLoader'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { tabs, tab } from 'vue-strap'

const backgroundColor = '#20a8d8'
const borderColor = 'rgba(255,255,255,.55)'

const backgroundMColor = '#85ace7'
const backgroundFColor = '#e258a7'

export default {
  components: {
    ReportLineChart,
    ReportBarChart,
    SyncLoader,
    tabs,
    tab,
    Multiselect,
    DotLoader
  },
  data () {
    var dateFilterOptions = [
      {label: this.$t('message.report.today'), value: 'today'},
      {label: this.$t('message.report.week'), value: 'week'},
      {label: this.$t('message.report.month'), value: 'month'},
      {label: this.$t('message.report.year'), value: 'year'}
    ]
    return {
      loading: false,
      activeTab: 0,
      dateFilterOptions: dateFilterOptions,
      selectedDateFilter: dateFilterOptions[0],
      stats: {
        demographicStat: {
          female: 0,
          male: 0
        },
        articleStat: [],
        doctorStat: [],
        appointmentStatusStat: [
          {status: 'pending', count: 0},
          {status: 'checkin', count: 0},
          {status: 'cancel', count: 0},
          {status: 'scheduled', count: 0}
        ]
      },
      orderedDoctorStat: [],
      appointmentStatChartData: {
        count: 0,
        labels: [],
        datasets: [
          {
            label: '',
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            data: []
          }
        ]
      },
      viewStatChartData: {
        count: 0,
        labels: [],
        datasets: [
          {
            label: '',
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            data: []
          }
        ]
      },
      genderStatChartData: {
        maleCount: 0,
        femaleCount: 0,
        labels: [],
        datasets: [
          {
            label: '',
            backgroundColor: backgroundMColor,
            borderColor: borderColor,
            data: []
          },
          {
            label: '',
            backgroundColor: backgroundFColor,
            borderColor: borderColor,
            data: []
          }
        ]
      }
    }
  },
  computed: {
    malePercent () {
      let total = this.stats.demographicStat.male + this.stats.demographicStat.female
      var percent = 0
      if (total > 0) {
        percent = (this.stats.demographicStat.male / total) * 100.0
      }
      return percent
    },
    femalePercent () {
      let total = this.stats.demographicStat.male + this.stats.demographicStat.female
      var percent = 0
      if (total > 0) {
        percent = (this.stats.demographicStat.female / total) * 100.0
      }
      return percent
    }
  },
  watch: {
    selectedDateFilter (v, o) {
      this.loadStats()
    }
  },
  methods: {
    getDoctorName (doctor) {
      if (doctor) {
        return `${doctor.prefix}${doctor.firstname} ${doctor.lastname}`
      }
      return ''
    },
    getAppointmentStatusCount (status) {
      let item = this.stats.appointmentStatusStat.find(it => it.status === status)
      if (item) {
        return item.count
      }
      return 0
    },
    openPath (id) {
      if (id) if (id) window.open(`${this.$APP_CONFIG.api.domain}${id}`, '_blank')
    },
    getParams () {
      var params = {}
      if (this.selectedDateFilter.value === 'today') {
        params = {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        }
      } else if (this.selectedDateFilter.value === 'week') {
        params = {
          start: moment().weekday(0).format('YYYY-MM-DD'),
          end: moment().weekday(6).format('YYYY-MM-DD')
        }
      } else if (this.selectedDateFilter.value === 'month') {
        params = {
          start: moment().format('YYYY-MM-1'),
          end: moment().format('YYYY-MM-') + moment().daysInMonth()
        }
      } else if (this.selectedDateFilter.value === 'year') {
        params = {
          start: moment().format('YYYY-01-1'),
          end: moment().format('YYYY-12-31')
        }
      }
      return params
    },
    async loadStats () {
      // Load Stats
      let self = this
      self.loading = true
      var url = ''
      var params = this.getParams()
      if (this.$guser.isClinicMulti()) {
        url = this.$APP_CONFIG.api.admin.clinic_stats(this.$guser.user.clinic.id)
      } else if (this.$guser.isClinic()) {
        url = this.$APP_CONFIG.api.admin.clinic_stats(this.$guser.user.clinic.id)
      } else {
        url = this.$APP_CONFIG.api.admin.doctor_stats(this.$guser.user.doctor.id)
      }
      let res = await this.$http.get(url, {params: params})

      if (res) {
        self.stats = Object.assign({}, self.stats, res.body)

        if (self.stats.appointmentStat) {
          self.appointmentStatChartData = Object.assign({}, {
            count: 0,
            labels: [],
            datasets: [
              {
                label: '',
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                data: []
              }
            ]
          })
          var appStatByDate = {}
          var viewStatByDate = {}

          let days = moment().daysInMonth()
          var n = 0
          for (n = 0; n < days; n++) {
            let key = moment(`${moment().format('YYYY-MM')}-${n + 1}`, 'YYYY-MM-DD').format('YYYY-MM-DD')
            appStatByDate[key] = {
              count: 0,
              date: key
            }
            viewStatByDate[key] = {
              count: 0,
              date: key
            }
          }

          self.stats.appointmentStat.forEach(data => {
            if (data.count && data.date) {
              appStatByDate[data.date] = {
                count: data.count,
                date: data.date
              }
            }
          })

          var key = null
          for (key in appStatByDate) {
            let dataDateObj = appStatByDate[key]
            if (dataDateObj.count >= 0 && dataDateObj.date) {
              self.appointmentStatChartData.datasets[0].data.push(dataDateObj.count)
              self.appointmentStatChartData.labels.push(dataDateObj.date)
              self.appointmentStatChartData.count += dataDateObj.count
            }
          }

          self.viewStatChartData = Object.assign({}, {
            count: 0,
            labels: [],
            datasets: [
              {
                label: '',
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                data: []
              }
            ]
          })
          self.stats.viewStat.forEach(data => {
            if (data.count && data.date) {
              viewStatByDate[data.date] = {
                count: data.count,
                date: data.date
              }
            }
          })

          for (key in viewStatByDate) {
            let dataDateObj = viewStatByDate[key]
            if (dataDateObj.count >= 0 && dataDateObj.date) {
              self.viewStatChartData.datasets[0].data.push(dataDateObj.count)
              self.viewStatChartData.labels.push(dataDateObj.date)
              self.viewStatChartData.count += dataDateObj.count
            }
          }
        }

        if (this.stats.doctorAppointment) {
          this.orderedDoctorStat = this.stats.doctorAppointment.sort((a, b) => b.appointment_count - a.appointment_count).splice(0, 20)
        }
      }

      self.loading = false
    }
  },
  created () {
    this.loadStats()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang='scss'>
@import "../../assets/base_container";

.appointmentStatTab ul li {
  width: 50%;
  text-align: center;
}

.appointmentStatTab  ul li:hover {
  background: lightcyan;
}

.appointmentStatTab ul li.active {
  border-bottom: 5px #2d3e70 solid !important;
}

.appointmentStatusStatTab ul li {
  width: 25%;
  text-align: center;
}

.appointmentStatusStatTab  ul li:hover {
  background: lightcyan;
}

// .appointmentStatTab ul li.active {
//   border-bottom: 5px #2d3e70 solid !important;
// }

.tab-content {
  border: 0px !important;
}

.tab-pane.fade {
  opacity: 1 !important;
}

.group-item-box {
  padding: 0 !important;
}

.gender-progress-box {
  padding: 0.5rem !important;
}

.male-progress {
  background-color: #85ace7 !important;
}

.female-progress {
  background-color: #e258a7 !important;
}

.apm-status-cnt-title {
  margin-top: 5px;
}

</style>



// WEBPACK FOOTER //
// Report.vue?19c921be